export enum HeaderEnum {
  MARKETING_HUB = 'Marketing hub',
  SOCTRIP = "Soctrip",
  TMTRAVEL = 'TMTravel'
}
